import { UserManager } from '@do/do-auth-web-client';
export const userManager = new UserManager();
userManager.init({
  env: window.ENV_CONFIG.env,
  loginUrl: window.ENV_CONFIG.loginUrl2,
  baseUrl: window.ENV_CONFIG.baseUrl,
  supportFs: true,
});
